export enum TodoListInteraction {
    UpdateList,
}
